import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { blockId } = attributes;
	return (
		<div
			{ ...useBlockProps.save( {
				className: `alpha-hero-block alpha-hero-block-${ blockId }`,
			} ) }
		>
			<InnerBlocks.Content />
		</div>
	);
}
